import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SfApprovalSettingApiNest } from "../../shared/nestjs/gd-only/services/sf-approval-setting.api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { SFApprovalSettingApi } from "../../shared/sdk/services/custom";

@Injectable()
export class WorkflowSettingBloc {
    constructor(
        private nestApiProvider: NestApiProvider,
        public SFApprovalSettingApi: SFApprovalSettingApi,
        private sfApprovalSettingApi: SfApprovalSettingApiNest
    ) {

    }

    getListing(): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(
                isGoPathNewExist => {
                    if (isGoPathNewExist) {
                        return this.sfApprovalSettingApi.getListing().pipe(map(result => result.data))
                    } else {
                        return this.SFApprovalSettingApi.getListing({a: 0})
                    }
                }
            )
    }

    getApprovalList():Observable<any>{
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(
                isGoPathNewExist => {
                    if (isGoPathNewExist) {
                        return this.sfApprovalSettingApi.getApprovalList().pipe(map(result => result.data))
                    } else {
                        return this.SFApprovalSettingApi.getApprovalList({ a: 0 })
                    }
                }
            )
    }

    save(data: any):Observable<any>{
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(
                isGoPathNewExist => {
                    if (isGoPathNewExist) {
                        return this.sfApprovalSettingApi.save(data).pipe(map(result => result.message))
                    } else {
                        return this.SFApprovalSettingApi.save(data)
                    }
                }
            )
    }

}


// WEBPACK FOOTER //
// ./src/bloc/settings/workflow-setting.bloc.ts